<template>
  <div class="d-none">
    <b-modal
      v-model="showModal"
      ref="confirmCancelModal"
      centered
      hide-header
      hide-footer
    >
      <div class="modal-header">
        <h4>{{ msg }}</h4>
        <button type="button" aria-label="Close" class="close" @click="hide">
          ×
        </button>
      </div>
      <div class="text-center px-md-5 py-4">
        <p class="text-text font-weight-bold">{{ text }}</p>
      </div>

      <div v-if="isRemark && labelRemark" class="pb-2">
        <div :class="['input-custom']">
          <label>
            {{ labelRemark }}
            <span class="text-danger">*</span>
          </label>
            <!-- :class="`form-control ${isValidate ? 'is-invalid' : ''}`" -->
          <textarea
            :class="`form-control ${isValidate ? 'error' : ''}`"
            :placeholder="placeholderRemark"
            name="remark"
            :rows="5"
            @change="checkRemark()"
            v-model="remark"
          />
          <div v-if="isValidate" class="invalid-feedback">
            {{ $t("required") }}
          </div>
        </div>
      </div>

      <div class="form-inline justify-content-center mt-2">
        <b-button class="mr-2 btn-modal" :variant="colorBtnCancel" @click="hide"
          >{{ btnCancel }}
        </b-button>
        <b-button
          class="ml-2 btn-modal"
          :variant="colorBtnConfirm"
          @click="clickConfirm()"
        >
          {{ btnConfirm }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    msg: {
      required: true,
      type: String,
    },
    text: {
      required: true,
      type: String,
    },
    labelRemark: {
      type: String,
    },
    placeholderRemark: {
      type: String,
    },
    isRemark: {
      type: Boolean,
    },
    btnConfirm: {
      required: true,
      type: String,
    },
    colorBtnConfirm: {
      required: false,
      type: String,
    },
    btnCancel: {
      required: true,
      type: String,
    },
    colorBtnCancel: {
      required: false,
      type: String,
    },
  },
  data() {
    return {
      showModal: false,
      isValidate: false,
      remark: "",
    };
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    checkRemark() {
      this.isValidate = this.remark ? false : true;
    },
    clickConfirm() {
      if (this.isRemark) {
        if (this.remark) {
          this.$emit("confirm", this.remark);
          this.isValidate = false;
        } else {
          this.isValidate = true;
        }
      } else this.$emit("confirm");
    },
  },
};
</script>

<style scoped>
.modal-header {
  border-bottom: 0 !important;
  margin: 0px;
  padding: 0px;
  padding-bottom: 0.25rem;
}
.text-msg {
  font-size: 2rem;
  color: #4a4a4a;
}
.text-text {
  color: #4a4a4a;
  margin-bottom: 0;
  font-size: 1.2rem;
}
.text-sub {
  color: #afce38;
  font-size: 1.25rem;
}
.modal-body {
  margin: auto;
  text-align: center;
  padding: 0;
}
.btn-modal {
  width: 140px;
  font-weight: bold;
}
</style>